'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemCleared = undefined;
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _es6Error = require('es6-error');
var _es6Error2 = _interopRequireDefault(_es6Error);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ItemCleared = exports.ItemCleared = function (_ExtendableError) {
  _inherits(ItemCleared, _ExtendableError);
  function ItemCleared(message) {
    _classCallCheck(this, ItemCleared);
    var _this = _possibleConstructorReturn(this, (ItemCleared.__proto__ || Object.getPrototypeOf(ItemCleared)).call(this, message));
    _this.errorCodes = [{
      code: 'item_cleared'
    }];
    return _this;
  }
  return ItemCleared;
}(_es6Error2.default);
var Queue = function () {
  function Queue() {
    _classCallCheck(this, Queue);
    this._items = [];
    this._isRunning = false;
    this.currentlyEnqueuedIdentifiers = this.currentlyEnqueuedIdentifiers.bind(this);
    this.clear = this.clear.bind(this);
    this.add = this.add.bind(this);
    this._run = this._run.bind(this);
  }
  _createClass(Queue, [{
    key: 'currentlyEnqueuedIdentifiers',
    value: function currentlyEnqueuedIdentifiers() {
      return this._items.map(function (item) {
        return item.identifier;
      });
    }
  }, {
    key: 'clear',
    value: function clear() {
      this._items.forEach(function (request) {
        return request.reject(new ItemCleared());
      });
      this._items = [];
    }
  }, {
    key: 'add',
    value: function add(promiseGenerator) {
      for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }
      var _this2 = this;
      var identifier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var promise = new Promise(function (resolve, reject) {
        _this2._items = _this2._items.concat({
          resolve: resolve,
          reject: reject,
          promiseGenerator: promiseGenerator,
          identifier: identifier,
          args: args
        });
      });
      if (!this._isRunning) this._run();
      return promise;
    }
  }, {
    key: '_run',
    value: function _run() {
      var _this3 = this;
      this._isRunning = true;
      if (this._items.length === 0) {
        this._isRunning = false;
        return;
      }
      var nextRequest = this._items.shift();
      nextRequest.promiseGenerator.apply(nextRequest, _toConsumableArray(nextRequest.args)).then(nextRequest.resolve).catch(nextRequest.reject).then(function () {
        return _this3._run();
      });
    }
  }]);
  return Queue;
}();
exports.default = Queue;